import parse, { domToReact } from "html-react-parser";

const ALLOWED_TAGS = [
  "p", "b", "strong", "i", "em",
  "ul", "ol", "li",
  "a", "br", "span"
];

const options = {
  replace: (node) => {
    if (!node.name) return;

    if (!ALLOWED_TAGS.includes(node.name)) {
      return null;
    }
    if (node.name === "br") {
      return <br />;
    }
    if (node.name === "a") {
      const href = node.attribs?.href;
      if (
        !href ||
        href.startsWith("javascript:") ||
        href.startsWith("data:")
      ) {
        return null;
      }
      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {domToReact(node.children, options)}
        </a>
      );
    }

    const TagName = node.name;

    return (
      <TagName>
        {domToReact(node.children, options)}
      </TagName>
    );
  }
};

export const parseSafeHtml = (html) => {
  return parse(html || "", options);
};
